import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import greenCircleIcon from "assets/svg/check-green-circle.svg";
import CheckBox from "components/common/checkBox/checkbox";
import {
  baseURLImage,
  filterNonPayrollRecords,
  getExportTimesheetSleepoverAllowanceUnits,
  getHrAndMinsFormatting,
  getNameProfile,
  getTimesheetProgressLabel,
  parseBooleanVal,
  textTruncate,
  checkWorkerAllTimesheetsSuccess,
  getAllNonSuccessTimesheets,
  hasCheckTimesheetStatus,
  checkWorkerAnyTimesheetsFailedOrError,
} from "Utils/utils";
import { HiCheck, HiOutlineMoon, HiXMark } from "react-icons/hi2";
import { PAYROLL_EXPORT_STATUS } from "Constants/constant";
import PayrollTimesheetStatusPopover from "../PayrollTimesheetStatusPopover";
import AvatarGroup from "components/common/Avatar/AvatarGroup";

const getProgressPillClass = (progress) => {
  switch (String(progress || "").toLowerCase()) {
    case "pay_approved":
    case "paid":
      return "bg-[#E2F8F6] text-[#0DBBB3]";
    case "submitted":
    case "started":
      return "bg-[#EEF2FB] text-[#4A6BB6]";
    case "future":
    case "un_submitted":
    case "created":
      return "bg-[#F8FAFC] text-[#64748B]";
    default:
      return "bg-[#F8FAFC] text-[#64748B]";
  }
};

const formatProgressLabel = (progress) => {
  const label = getTimesheetProgressLabel(progress);
  if (!label) return "—";
  return label
    .split(" ")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

const ExportSelectedTimesheetItem = (props) => {
  const {
    isAuthenticateForPayrolls,
    workerTimeSheets,
    handleChildItemTimeSheet,
    isUserGracePeriodOver,
  } = props;

  const [isCollapsed, setIsCollapsed] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  const [export_status_key, setExportStatusKey] = useState(
    // `${isAuthenticateForPayroll}_export_status`
    ""
  );

  useEffect(() => {
    if (isAuthenticateForPayrolls !== null) {
      const isTrueAny = Object.keys(isAuthenticateForPayrolls || {})?.find(
        (x) => {
          if (parseBooleanVal(isAuthenticateForPayrolls[`${x}`])) {
            return x;
          }
          return false;
        }
      );
      if (isTrueAny) {
        setExportStatusKey(`${isTrueAny}_export_status`);
      }
    }
  }, [isAuthenticateForPayrolls]);

  useEffect(() => {
    setSelectAll(false);
  }, []);

  const isAllSuccess = useMemo(() => {
    return (
      checkWorkerAllTimesheetsSuccess(workerTimeSheets?.timeSheet).length ===
      workerTimeSheets?.timeSheet?.length
    );
  }, [workerTimeSheets?.timeSheet]);

  const isAnyFailed = useMemo(() => {
    return checkWorkerAnyTimesheetsFailedOrError(workerTimeSheets?.timeSheet)
      .length > 0
      ? true
      : false;
  }, [workerTimeSheets?.timeSheet]);

  useEffect(() => {
    setSelectAllCheckBox();
  }, [workerTimeSheets?.children]);

  const setSelectAllCheckBox = () => {
    if (isAllSuccess) {
      setSelectAll(true);
    } else if (
      workerTimeSheets?.timeSheet?.length === workerTimeSheets?.children?.length
    ) {
      setSelectAll(true);
    } else if (
      workerTimeSheets?.children.length > 0 &&
      workerTimeSheets?.children?.length ===
        getAllNonSuccessTimesheets(workerTimeSheets?.timeSheet).length
    ) {
      setSelectAll(true);
    } else setSelectAll(false);
  };

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleWorkerImageError = (e) => {
    e.target.src = getNameProfile(
      workerTimeSheets?.first_name || "",
      workerTimeSheets?.last_name || ""
    );
  };

  const getExportPayrollIcon = (item) => {
    if (hasCheckTimesheetStatus(item, PAYROLL_EXPORT_STATUS.SUCCESS)) {
      return (
        <span
          className='inline-flex h-6 w-6 items-center justify-center rounded-full bg-[#E2F8F6] text-[#0DBBB3] ring-1 ring-[#0DBBB3]/20'
          title='Exported successfully'
        >
          <HiCheck className='h-3.5 w-3.5' strokeWidth={2.5} aria-hidden />
        </span>
      );
    }
    if (
      hasCheckTimesheetStatus(item, PAYROLL_EXPORT_STATUS.FAILED) ||
      hasCheckTimesheetStatus(item, PAYROLL_EXPORT_STATUS.ERROR)
    ) {
      return (
        <span
          className='inline-flex h-6 w-6 items-center justify-center rounded-full bg-[#FEE9EE] text-[#FC466C] ring-1 ring-[#FC466C]/20'
          title='Export failed'
        >
          <HiXMark className='h-3.5 w-3.5' strokeWidth={2.5} aria-hidden />
        </span>
      );
    }
    if (hasCheckTimesheetStatus(item, PAYROLL_EXPORT_STATUS.INITIATED)) {
      return (
        <span
          className='inline-flex h-6 w-6 items-center justify-center rounded-full bg-[#FEF4E2] text-[#F59E0B] ring-1 ring-[#F59E0B]/25'
          title='Export in progress'
        >
          <span className='h-2 w-2 rounded-full bg-[#F59E0B]' aria-hidden />
        </span>
      );
    }
    return (
      <span className='text-xs font-medium text-[#94A3B8]' title='Not exported'>
        —
      </span>
    );
  };

  useEffect(() => {
    handleChildItemTimeSheet(workerTimeSheets.uuid, null, null, null, true);
  }, []);
  return (
    <div className='overflow-hidden rounded-xl border border-[#E5E7EB] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]'>
      <table className='w-full divide-y divide-[#E5E7EB]'>
        <thead className='border-b border-[#E5E7EB] bg-[#F8FAFC]'>
          <tr>
            <th className='flex w-[10%] items-center space-x-3 p-3 text-start'>
              {isCollapsed && (
                <CheckBox
                  checked={selectAll}
                  isDisabled={isAllSuccess || isUserGracePeriodOver}
                  handleChange={() => {
                    if (isUserGracePeriodOver) {
                      return;
                    }
                    handleChildItemTimeSheet(
                      workerTimeSheets.uuid,
                      null,
                      null,
                      null,
                      !selectAll
                    );
                    setSelectAll(!selectAll);
                  }}
                  cssClass='border-gray-500 rounded-sm'
                />
              )}
              <button
                type='button'
                className='text-xs text-[#64748B]'
                onClick={toggleCollapse}
                aria-label={isCollapsed ? "Collapse" : "Expand"}
              >
                {!isCollapsed ? "▶" : "▼"}
              </button>
            </th>
            <th
              title={`${workerTimeSheets.first_name} ${workerTimeSheets.last_name}`}
              className='w-[30%] p-3 text-start'
            >
              <div className='flex min-w-0 items-center gap-2.5'>
                <div className='h-8 w-8 flex-shrink-0'>
                  <img
                    onError={handleWorkerImageError}
                    className='h-8 w-8 rounded-full object-cover'
                    src={
                      workerTimeSheets?.photo
                        ? baseURLImage(workerTimeSheets.photo)
                        : getNameProfile(
                            workerTimeSheets?.first_name || "",
                            workerTimeSheets?.last_name || ""
                          )
                    }
                    alt=''
                  />
                </div>
                <div className='flex min-w-0 items-center gap-1.5'>
                  <span className='truncate text-sm font-semibold capitalize text-[#0F172A]'>
                    {textTruncate(
                      `${workerTimeSheets.first_name} ${workerTimeSheets.last_name}`,
                      23,
                      22
                    )}
                  </span>
                  <PayrollTimesheetStatusPopover
                    isAllSuccess={isAllSuccess}
                    isAnyFailed={isAnyFailed}
                    item={workerTimeSheets}
                    isPayrollIdExists={filterNonPayrollRecords(
                      workerTimeSheets
                    )}
                    payrollType={workerTimeSheets.payroll_platform}
                  />
                </div>
              </div>
            </th>
            <th className='w-[50%] p-3 text-start text-sm font-medium text-[#64748B]'>
              {`Total Hours: ${getHrAndMinsFormatting(
                workerTimeSheets.ttl_timesheet_length
              )}`}
            </th>
            <th className='w-[12%] min-w-[96px] p-3 text-center'>
              <span className='inline-flex items-center rounded-md bg-[#EEF2FB] px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-[#4A6BB6]'>
                Progress
              </span>
            </th>
            <th className='w-[10%] min-w-[88px] p-3 text-center'>
              <span className='inline-flex items-center rounded-md bg-[#F1F5F9] px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-[#64748B]'>
                Exported
              </span>
            </th>
          </tr>
        </thead>
        {isCollapsed && (
          <tbody className='transition-all duration-300 ease-linear'>
            {workerTimeSheets.timeSheet.map((item, index) => {
              const isSleepover = parseBooleanVal(item.sleepover);
              const sleepoverUnits = isSleepover
                ? getExportTimesheetSleepoverAllowanceUnits(item)
                : 0;
              return (
              <tr
                key={item.uuid || index}
                className='border-t border-[#E5E7EB] bg-white hover:bg-[#EEF2FB]/60'
              >
                <td className='w-[10%] align-middle px-3 py-3'>
                  <CheckBox
                    handleChange={(e) => {
                      if (isUserGracePeriodOver) {
                        return;
                      }
                      handleChildItemTimeSheet(
                        workerTimeSheets.uuid,
                        e,
                        item.uuid,
                        item
                      );
                    }}
                    isDisabled={
                      hasCheckTimesheetStatus(
                        item,
                        PAYROLL_EXPORT_STATUS.SUCCESS
                      ) || isUserGracePeriodOver
                    }
                    checked={
                      hasCheckTimesheetStatus(
                        item,
                        PAYROLL_EXPORT_STATUS.SUCCESS
                      ) ||
                      (workerTimeSheets?.children?.find(
                        (x) => x.uuid === item.uuid
                      )
                        ? true
                        : false)
                    }
                    cssClass='border-gray-500 rounded-sm'
                  />
                </td>
                <td className='w-[30%] px-3 py-3'>
                  <AvatarGroup
                    type='participant'
                    arrayData={item?.participants || []}
                    cssClass='mt-0'
                    maxLength={3}
                    isNoRing
                  />
                </td>
                <td className='w-[50%] px-3 py-3'>
                  <div className='flex flex-col gap-1'>
                    {isSleepover && (
                      <div
                        className='inline-flex w-fit items-center gap-1 rounded-full bg-[#EEF2FB] px-2 py-0.5 text-[11px] font-medium text-[#4A6BB6]'
                        title='Sleepover timesheet'
                      >
                        <HiOutlineMoon className='h-3.5 w-3.5' aria-hidden />
                        Sleepover · 10pm–6am ({sleepoverUnits} unit
                        {sleepoverUnits === 1 ? "" : "s"})
                        {String(item.active_hours || "").trim()
                          ? ` · Active ${String(item.active_hours).trim()}`
                          : ""}
                      </div>
                    )}
                    <div className='flex items-center justify-start'>
                      <img src={greenCircleIcon} alt='green circle' />
                      <span className='ml-1 text-xs font-medium leading-5 text-[#64748B]'>
                        {moment(item.time_sheet_date).format("ddd, D/MM ")}
                        {moment(item.start_time).format("| hh:mm a ")}
                        {moment(item.end_time).format(
                          isSleepover ? "- hh:mm a" : "- hh:mm a | "
                        )}
                        {!isSleepover &&
                          item.timesheet_length &&
                          item.timesheet_length.includes(":") &&
                          `${item.timesheet_length.split(":")[0]}hr ${
                            item.timesheet_length.split(":")[1]
                          }mins`}
                      </span>
                    </div>
                  </div>
                </td>
                <td className='w-[12%] min-w-[96px] whitespace-nowrap px-3 py-3 text-center'>
                  <span
                    className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold leading-4 ${getProgressPillClass(
                      item.progress
                    )}`}
                  >
                    {formatProgressLabel(item.progress)}
                  </span>
                </td>
                <td className='w-[10%] min-w-[88px] px-3 py-3'>
                  <div className='flex w-full items-center justify-center'>
                    {getExportPayrollIcon(item)}
                  </div>
                </td>
              </tr>
            );
            })}
          </tbody>
        )}
      </table>
    </div>
  );
};

export default ExportSelectedTimesheetItem;
